<template>
    <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="formDisabled">
            <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="计划" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="planId">
                            <a-input disabled v-model="model.planId_dictText" placeholder="请输入计划" style="width: 100%" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="巡检结果" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="recordRes">
                            <j-switch v-model="model.recordRes" checked-children="正常" un-checked-children="异常" :options="recordResOptions"></j-switch>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-form-model-item label="复核说明" :labelCol="{xs: { span: 24 },sm: { span: 3 }}" :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}" prop="reviewRemarks">
                            <a-textarea v-model="model.reviewRemarks" placeholder="请输入复核说明" allow-clear :rows="4"></a-textarea>
                        </a-form-model-item>
                        <a-form-model-item v-show="false" label="复核状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="reviewStatus">
                            <j-dict-select-tag disabled v-model="model.reviewStatus" placeholder="请选择复核状态" dictCode="patrol_record_review_status" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12">
                        <a-form-model-item label="复核人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="reviewPerson">
                            <a-select disabled v-model:value="model.reviewPerson" show-search :filter-option="filterOption" allowClear placeholder="请输入复核人" :show-arrow="false" :not-found-content="null" @search="remoteUserList">
                                <a-select-option v-for="item in UserOptions" :key="item.id" :value="item.id">{{item.realname}} </a-select-option>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="巡检时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="recordTime">
                            <j-date disabled :showTime="true" dateFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择巡检时间" v-model="model.recordTime" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </j-form-container>
    </a-spin>
</template>

<script>
    import { httpAction, getAction } from '@/api/manage'
    import { validateDuplicateValue } from '@/utils/util'
    import { getUserList } from '@/api/api'

    export default {
        name: 'YwIntelligentPatrolRecordForm',
        components: {},
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data() {
            return {
                model: {},
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 6 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
                confirmLoading: false,
                validatorRules: {},
                url: {
                    add: "/maintenance/ywIntelligentPatrolRecord/add",
                    edit: "/maintenance/ywIntelligentPatrolRecord/edit",
                    queryById: "/maintenance/ywIntelligentPatrolRecord/queryById"
                },
                UserOptions: [],
                recordResOptions: [1, 2]
            }
        },
        computed: {
            formDisabled() {
                return this.disabled
            },
            userInfo() {
                return this.$store.getters.userInfo
            }
        },
        created() {
            //备份model原始值
            this.modelDefault = JSON.parse(JSON.stringify(this.model));
            this.remoteUserList()
        },
        methods: {
            add() {
                this.edit(this.modelDefault);
            },
            edit(record) {
                this.model = Object.assign({}, record);
                this.model.reviewPerson = this.userInfo.id
                this.model.reviewStatus = 1
                this.visible = true;
            },
            submitForm() {
                const that = this;
                // 触发表单验证
                this.$refs.form.validate(valid => {
                    if (valid) {
                        that.confirmLoading = true;
                        let httpurl = '';
                        let method = '';
                        if (!this.model.id) {
                            httpurl += this.url.add;
                            method = 'post';
                        } else {
                            httpurl += this.url.edit;
                            method = 'put';
                        }
                        httpAction(httpurl, this.model, method).then((res) => {
                            if (res.success) {
                                that.$message.success(res.message);
                                that.$emit('ok');
                            } else {
                                that.$message.warning(res.message);
                            }
                        }).finally(() => {
                            that.confirmLoading = false;
                        })
                    }

                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remoteUserList(query) {
                let params = {
                    username: query,
                    // realname: query,
                    // phone: query,
                    // workNo: query
                }
                let sqp = {}
                // sqp['superQueryParams'] = encodeURI(params)
                // sqp['superQueryMatchType'] = 'or'
                getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
                    this.UserOptions = res.result.records;
                })
            },
        }
    }
</script>